import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../components/global/Button';
import { getAsset } from '../../../../../../util/assets';

const propTypes = {
  onRequestClose: PropTypes.func,
};

const SuccessStep = ({ onRequestClose }) => {
  return (
    <div className="text-center mt-6">
      <img
        src={getAsset('/waldo-excited.png')}
        className="mb-3"
        width="60"
        alt="Waldo Icon"
      />
      <h3>
        Purchase complete!
        <br />
        Your gift has been activated for the event
      </h3>
      <p>A receipt has been sent to your email.</p>
      {onRequestClose && (
        <Button
          data-testid="close-action"
          className="mt-2"
          onClick={onRequestClose}
        >
          Got it
        </Button>
      )}
    </div>
  );
};

SuccessStep.propTypes = propTypes;

export default SuccessStep;
